import React, {useEffect, useState} from "react";

const sections = [
  "Information We Collect",
  "How We Use Your Information",
  "Cookies and Tracking Technologies",
  "Third Party Services",
  "Data Sharing",
  "Data Security",
  "Data Retention",
  "User Rights",
  "Marketing Communications",
  "Children's Privacy",
  "International Data Transfers",
  "Intellectual Property and Platform Data",
  "Changes to This Privacy Policy",
  "Contact Us",
];

function PrivacyPolicy() {
    const [activeSection, setActiveSection] = useState(1);

useEffect(() => {
  const sections = document.querySelectorAll(".ax-privacy-card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id.split("-")[1];
          setActiveSection(Number(sectionId));
        }
      });
    },
    {
      threshold: 0.3,
      rootMargin: "-100px 0px -50% 0px",
    }
  );

  sections.forEach((section) => observer.observe(section));

  return () => observer.disconnect();
}, []);
  return (
    <section className="ax-privacy-page">
      {/* Hero */}
      <div className="ax-privacy-hero">
        <div className="container">
          {/* <span className="ax-privacy-badge">
            Last Updated • 01 June 2026
          </span> */}

          <h1>
            Privacy <span>Policy</span>
          </h1>

          <p>
            Your privacy matters to us. Learn how AxeSell collects,
            uses, stores and protects your information.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {/* Sidebar */}
          <div className="col-lg-3">
            <div className="ax-privacy-sidebar">
              <h5>Contents</h5>

              {sections.map((item, index) => (
               <a
  key={index}
  href={`#section-${index + 1}`}
  className={
    activeSection === index + 1
      ? "ax-privacy-active"
      : ""
  }
>
                  {index + 1}. {item}
                </a>
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="col-lg-9">
            <div className="ax-privacy-content">

              <div
                id="section-1"
                className="ax-privacy-card"
              >
                <h2>1. Information We Collect</h2>

                <h4>A. Information You Provide</h4>

                <ul>
                  <li>Full Name</li>
                  <li>Business Name</li>
                  <li>Email Address</li>
                  <li>Mobile Number</li>
                  <li>Billing Information</li>
                  <li>Business Address</li>
                  <li>GST Details (if applicable)</li>
                  <li>Website Content and Product Information</li>
                  <li>Support Requests and Communications</li>
                  <li>Documents submitted during onboarding</li>
                </ul>

                <h4>B. Information Collected Automatically</h4>

                <ul>
                  <li>IP Address</li>
                  <li>Device Information</li>
                  <li>Browser Type</li>
                  <li>Operating System</li>
                  <li>Geographic Location</li>
                  <li>Website Usage Data</li>
                  <li>Pages Visited</li>
                  <li>Time Spent on Website</li>
                  <li>Referral Sources</li>
                  <li>Cookies and Similar Technologies</li>
                </ul>

                <h4>C. Ecommerce Store Data</h4>

                <ul>
                  <li>Product Information</li>
                  <li>Inventory Data</li>
                  <li>Customer Orders</li>
                  <li>Customer Contact Information</li>
                  <li>Shipping Information</li>
                  <li>Transaction Records</li>
                  <li>Website Analytics</li>
                </ul>
              </div>

              <div
                id="section-2"
                className="ax-privacy-card"
              >
                <h2>2. How We Use Your Information</h2>

                <ul>
                  <li>Create and manage your account</li>
                  <li>Deploy and maintain your online store</li>
                  <li>Provide customer support</li>
                  <li>Process payments and subscriptions</li>
                  <li>Deliver training and onboarding services</li>
                  <li>Improve platform performance</li>
                  <li>Communicate updates and service notifications</li>
                  <li>Provide marketing communications</li>
                  <li>Detect fraud and unauthorized activities</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div
                id="section-3"
                className="ax-privacy-card"
              >
                <h2>3. Cookies and Tracking Technologies</h2>

                <p>
                  We may use cookies, analytics tools, pixels and
                  similar technologies to improve functionality,
                  understand visitor behaviour, personalize user
                  experiences and optimize marketing campaigns.
                </p>
              </div>

              <div
                id="section-4"
                className="ax-privacy-card"
              >
                <h2>4. Third Party Services</h2>

                <ul>
                  <li>Payment Gateways</li>
                  <li>Shipping Partners</li>
                  <li>SMS Providers</li>
                  <li>Email Service Providers</li>
                  <li>WhatsApp Business Services</li>
                  <li>Analytics Platforms</li>
                  <li>Advertising Platforms</li>
                  <li>Cloud Hosting Providers</li>
                </ul>
              </div>

              <div
                id="section-5"
                className="ax-privacy-card"
              >
                <h2>5. Data Sharing</h2>

                <p>
                  We do not sell your personal information. Data may
                  only be shared for service delivery, legal
                  compliance, business transfers or protection of
                  rights.
                </p>
              </div>

              <div
                id="section-6"
                className="ax-privacy-card"
              >
                <h2>6. Data Security</h2>

                <p>
                  We implement commercially reasonable safeguards
                  against unauthorized access, alteration,
                  disclosure, loss and misuse.
                </p>
              </div>

              <div
                id="section-7"
                className="ax-privacy-card"
              >
                <h2>7. Data Retention</h2>

                <p>
                  We retain information only as long as necessary to
                  provide services, comply with laws, resolve
                  disputes and enforce agreements.
                </p>
              </div>

              <div
                id="section-8"
                className="ax-privacy-card"
              >
                <h2>8. User Rights</h2>

                <ul>
                  <li>Access Personal Information</li>
                  <li>Correct Information</li>
                  <li>Request Deletion</li>
                  <li>Withdraw Consent</li>
                  <li>Object to Processing</li>
                  <li>Request Data Portability</li>
                </ul>
              </div>

              <div
                id="section-9"
                className="ax-privacy-card"
              >
                <h2>9. Marketing Communications</h2>

                <p>
                  Users may opt out of promotional communications
                  anytime using unsubscribe links or by contacting
                  us directly.
                </p>
              </div>

              <div
                id="section-10"
                className="ax-privacy-card"
              >
                <h2>10. Children's Privacy</h2>

                <p>
                  AxeSell services are intended for users aged 18+
                  and businesses. We do not knowingly collect data
                  from children.
                </p>
              </div>

              <div
                id="section-11"
                className="ax-privacy-card"
              >
                <h2>11. International Data Transfers</h2>

                <p>
                  Your information may be processed and stored in
                  locations where our service providers operate.
                </p>
              </div>

              <div
                id="section-12"
                className="ax-privacy-card"
              >
                <h2>12. Intellectual Property and Platform Data</h2>

                <p>
                  AxeSell retains ownership of its proprietary
                  platform, software architecture, APIs,
                  infrastructure and technology systems.
                </p>
              </div>

              <div
                id="section-13"
                className="ax-privacy-card"
              >
                <h2>13. Changes to This Privacy Policy</h2>

                <p>
                  We may update this Privacy Policy periodically.
                  Continued use of our services constitutes
                  acceptance of revised terms.
                </p>
              </div>

              <div
                id="section-14"
                className="ax-privacy-card"
              >
                <h2>14. Contact Us</h2>

                <div className="ax-contact-box">
                  <h4>Axepert Exhibits Private Limited</h4>

                  <p>Email: mail@axesell.com</p>

                  <p>Website: www.axesell.in</p>

                  <p>Phone: 011-43220041</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;